import React, { Component } from 'react';

import comingSoonConfig from '../../config/coming-soon.json';

import $ from 'jquery';

class Gallery extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ...this.props,
      slide: 0
    }
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;

    const toFunc = function(){
      console.log('polling t.props.data...')
      if (typeof t.props.data !== 'undefined') {
        t.setState({
          data: t.props.data
        });
      } else {
        t.t0 = setTimeout(toFunc, 500);
      }
    }

    this.t0 = setTimeout(toFunc, 500);

    t.pageLoad();

    this.changePositioning();
    this.props.updateLang();
    window.addEventListener('resize', this.changePositioning);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);

    clearTimeout(this.t0);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();
  }

  changePositioning() {
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 500)
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 1000)
    setTimeout(function(){
      $('.mobile-main-page').css({
        'height': $('.mobile-main-page-bg').css('height')
      })
    }, 1500)
  }
  
  goToNextImage(op) {


    if (op === 'left') {
      if (this.state.slide - 1 < 0) {
        // console.log(11111)
        this.setState({
          slide: this.state.data.gallery.length - 1
        })
        $('#mobile-gallary-slider').css({'top': (this.state.data.gallery.length - 1) * -100 + '%'});
      } else {
        // console.log(22222)
        this.setState({
          slide: this.state.slide - 1
        })
        $('#mobile-gallary-slider').css({'top': (this.state.slide - 1) * -100 + '%'});
      }
    } else {
      if (this.state.slide + 1 >= this.state.data.gallery.length) {
        // console.log(33333)
        this.setState({
          slide: 0
        })
        $('#mobile-gallary-slider').css({'top': '0%'});
      } else {
        // console.log(44444)
        this.setState({
          slide: this.state.slide + 1
        })
        $('#mobile-gallary-slider').css({'top': (this.state.slide + 1) * -100 + '%'});
      }
    }

    console.log(op);
    console.log(this.state.slide);
    console.log(this.state.data.gallery.length);
  }

  render() {
    let t = this;
    return <div className='mobile-main-page-container' style={{
    
    }}>
      <div className='mobile-main-page' style={{

      }}>
        <img className='mobile-main-page-bg' src={'/p2/mobile/page/' + this.props.lang + '/gallery.png'} style={{
          'minWidth': '100%',
          'width': '100%'
        }}/>

        <div className='mobile-main-page-content-container' style={{
          'position': 'absolute',
          'top': '72%',
          'left': '8%',
          'width': '15%',
          'height': '6%',
          'textAlign': 'left'
        }} onClick={() => t.goToNextImage('left')}>
          {/* <i className='material-icons'
            style={{
              fontSize: '48px',
              position: 'relative',
              color: '#ecacd2'
            }}>chevron_left</i> */}
        </div>
        <div className='mobile-main-page-content-container' style={{
          'position': 'absolute',
          'top': '72%',
          'right': '8%',
          'width': '15%',
          'height': '6%',
          'textAlign': 'right'
        }} onClick={() => t.goToNextImage('right')}>
          {/* <i className='material-icons'
            style={{
              fontSize: '48px',
              position: 'relative',
              color: '#ecacd2'
            }}>chevron_right</i> */}
        </div>

        <div className='mobile-main-page-content-container' style={{
          'top': (t.props.lang == 'en' ? '38%' : '39.5%'),
          'left': '21%',
          'width': '58%',
          'height': '15%',
          'overflow': 'hidden'
        }}>
          <div id='mobile-gallary-slider' className='mobile-gallary-slider' style={{
            'width': '100%',
            'height': '100%',
            'position': 'relative'
          }}>
              {this.state.data && this.state.data.gallery && this.state.data.gallery.length > 0 ?
                this.state.data.gallery.map(function(elem, idx){
                  let renderType = elem.img ? 'img' : 'pdf';
                  let objToRender = '';

                  // this.setState({
                  //   slideCount: this.state.slideCount + 1
                  // });

                  
                  if (renderType === 'img') {
                    let imgSrc = 'url(' + elem.img + ')';
                    objToRender = <a key={idx} href={elem.img} target='_blank'><div className='mobile-gallary-image-pre' style={{
                      'backgroundImage': imgSrc,
                      'height': '100%',
                      'backgroundColor': 'rgba(255,170,168,0.8)',
                      'backgroundPosition': 'center',
                      'backgroundSize': 'cover'
                    }}>
                    </div></a>
                  }
                  else {
                    objToRender = <a key={idx} href={elem.url} target='_blank' style={{'textDecoration': 'none'}}>
                      <div className='mobile-gallary-image-pre' style={{
                      'color': 'white',
                      'height': '100%',
                      // 'height': '57.3%',
                      // 'paddingTop': '33%',
                      'textAlign': 'center',
                      'backgroundColor': 'rgba(255,170,168,0.8)',
                      'fontFamily': 'Roboto Condensed, sans-serif',
                      backgroundImage: 'url(/p2/desktop/gallery/bg-for-non-image.png)'
                    }}>
                      <div style={{height: '44%'}}></div>
                      {elem[t.state.lang]}
                      </div>
                    </a>
                  }
                  return objToRender

                }) : <div style={{
                  'color': 'white',
                  'marginTop': '28%',
                  'padding': '6px 0',
                  'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
                  'textAlign': 'center'
                }}>{comingSoonConfig[t.state.lang]}</div>
              }
          </div>
        </div>

      </div>
    </div>
  }

};

export default Gallery;



// WEBPACK FOOTER //
// ./src/mobile/page/Gallery.js